// Suivi des erreurs navigateur (Sentry, organisation kly-groupe).
// Le DSN n'est PAS un secret (envoi seulement) ; VITE_SENTRY_DSN le remplace.
// Actif UNIQUEMENT dans le build de production : `npm run dev` n'envoie rien.
// Pas de Session Replay : les ecrans montrent des tickets et donnees clients.
import * as Sentry from '@sentry/react';

const DSN_DEFAUT =
  'https://946a2845fd9df91c17104046d62629b2@o4510816974929920.ingest.de.sentry.io/4510816976699472';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || DSN_DEFAUT,
  enabled: import.meta.env.PROD,
  environment: import.meta.env.MODE,
  // Sentry 11 collecte par defaut cookies, en-tetes et corps des requetes :
  // ici ce seraient tickets et donnees clients. Tout est coupe.
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: false,
    httpBodies: [],
    urlQueryParams: false,
    stackFrameVariables: false,
  },
  initialScope: { tags: { app: 'sav-admin' } },
});
